<template>
  <div>
    <h4 :style="{ margin: '0 0 20px 20px' }">
      {{ title }}
      <a-button v-show="showReturnBtn" type="primary" @click="handleReturn">返回上级</a-button>
    </h4>
    <v-chart
      :force-fit="true"
      :height="height"
      :padding="[40, 40, 'auto', 40]"
      :data="data"
      :onClick="handleClick"
    >
      <v-tooltip />
      <v-axis />
      <v-legend class="viser-legend" />
      <v-line position="type*y" color="x" />
      <v-point position="type*y" color="x" :size="4" :v-style="style" :shape="'circle'" />
    </v-chart>
  </div>
</template>

<script>
import { DataSet } from '@antv/data-set'
import { ChartEventMixins } from './mixins/ChartMixins'

export default {
  name: 'LineChartMultid',
  mixins: [ChartEventMixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    // 别名，需要的格式：[{field:'name',alias:'姓名'}, {field:'sex',alias:'性别'}]
    aliases: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 400,
    },
    showReturnBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      style: { stroke: '#fff', lineWidth: 1 },
    }
  },
  computed: {
    data() {
      const dv = new DataSet.View().source(this.dataSource)
      dv.transform({
        type: 'fold',
        fields: this.fields,
        key: 'x',
        value: 'y',
      })
      let rows = dv.rows
      // 替换别名
      rows.forEach((row) => {
        for (let item of this.aliases) {
          if (item.field === row.x) {
            row.x = item.alias
            break
          }
        }
      })
      return rows
    },
  },
}
</script>

<style scoped></style>
